import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class CustomTextArea extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
    
  handleChange(e, onChange, maxLength) {
    if(maxLength && e.target.value.length >= maxLength + 1) {
      return null;
    }
    onChange(e);
  }

  render() {
    const {
      field,
      form: { touched, errors },
      showError,
      minLength,
      maxLength,
      placeholder,
      t,
    } = this.props;

    const isError = touched[field.name] && errors[field.name];

    return (
      <>
        <textarea
          rows="3"
          className={isError ? 'fe-form-error-input' : ''}
          placeholder={placeholder}
          {...field}
          onChange={(e) => this.handleChange(e, field.onChange, maxLength)}
        />
        <div className="fe-form-flex-error">
          { showError && isError ? <span className="fe-form-error">{t(`error:${errors[field.name]}`, { num: minLength })}</span> : <span></span> }
          {maxLength ? 
            <div className="fe-text-max-length">
              {field.value ? field.value.length : '0'} / {maxLength}
            </div> : null}
        </div>
      </>
    );
  }
    
}

CustomTextArea.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  showError: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  t: PropTypes.func.isRequired,
};

CustomTextArea.defaultProps = {
  showError: true,
  minLength: 10,
  maxLength: 500,
};

export default withTranslation()(CustomTextArea);